export default "__VITE_ASSET__DipEHJAg__"